export default function parseJsonSafely(text: string): object | string {
  if (typeof text === 'object') {
    return text;
  }

  try {
    return JSON.parse(text);
  } catch (e) {
    if ((e as Error).name !== 'SyntaxError') {
      throw e;
    }
    return text.trim();
  }
}
